import { GlobalState } from '../reducers';

export const getServiceNamesState = (state: GlobalState) => state.services.serviceNames;
export const getServiceNamesLookupState = (state: GlobalState) => state.services.serviceNamesLookup;
